/*
 * @Author: your name
 * @Date: 2022-03-01 13:56:28
 * @LastEditTime: 2022-03-18 15:51:20
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\www\src\components\inject\antd.tsx
 */
import { $AppConfig } from '@/plugins/global';
import { Alert, Avatar, Button, Card, Carousel, Cascader, Checkbox, Col, Divider, Drawer, Dropdown, Empty, Form, Image, Input, Layout, Menu, Modal, Pagination, Popconfirm, Result, Row, Space, Tabs, Tooltip, Transfer, Upload } from 'antd';
import ConfigProvider, { ConfigProviderProps } from 'antd/es/config-provider';
import Spin, { SpinProps } from 'antd/es/spin';
import Countdown from 'antd/es/statistic/Countdown';
import React, { PropsWithChildren } from 'react';
import Icon from './icons';
ConfigProvider.config({
    prefixCls: $AppConfig.prefixCls, // 4.13.0+
});
Spin.setDefaultIndicator(<Icon.LoadingOutlined style={{ fontSize: 40 }} spin />)
export default {
    ConfigProvider: function (props: Partial<ConfigProviderProps>) {
        return <ConfigProvider prefixCls={$AppConfig.prefixCls} {...props} />
    },//: React.lazy<typeof ConfigProvider>(() => import('antd/es/config-provider')),
    Divider,//: React.lazy<typeof Divider>(() => import('antd/es/divider')),
    Avatar: React.lazy<typeof Avatar>(() => import('antd/es/avatar')),
    Spin: function (props: PropsWithChildren<SpinProps>) {
        return <Spin tip='Loading...' {...props} >{props.children}</Spin>
    },
    Modal,
    Drawer,
    Form,
    Tabs,
    Popconfirm,
    Space,
    Checkbox,
    Dropdown: React.lazy<typeof Dropdown>(() => import('antd/es/dropdown')),
    Menu,//: React.lazy<typeof Menu>(() => import('antd/es/menu')),
    Empty,//: React.lazy<typeof Empty>(() => import('antd/es/empty')),
    Pagination: React.lazy<typeof Pagination>(() => import('antd/es/pagination')),
    Transfer: React.lazy<typeof Transfer>(() => import('antd/es/transfer')),
    Upload: React.lazy<typeof Upload>(() => import('antd/es/upload')),
    Button,//: React.lazy<typeof Button>(() => import('antd/es/button')),
    Image,//: React.lazy<typeof Image>(() => import('antd/es/image')),
    Result,
    Countdown,
    Card,
    Tooltip,
    Col,
    Row,
    Layout,
    Carousel,
    Cascader,
    Alert,
    Input
}
